const noos = [
    { id: "Y", label: "Y" },
    { id: "N", label: "N" }
  ]
  
  export const getNoos = id => noos.find(noos => noos.id === id)
  export const allNoos = noos.map(({ id }) => id)
  
  export default noos